// extracted by mini-css-extract-plugin
export default {"root":"CardContent_root__413D1"};